import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function AuditorDetailSkeleton() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-center mb-6">
        <Skeleton width={200} height={30} />
      </h1>
      <div className="space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Skeleton for input fields */}
          {Array.from({ length: 12 }).map((_, index) => (
            <div key={index}>
              <Skeleton width={100} height={20} />
              <Skeleton
                width="100%"
                height={40}
                style={{ marginTop: "8px", borderRadius: "8px" }}
              />
            </div>
          ))}

          {/* Skeleton for Datepicker */}
          <div>
            <Skeleton width={100} height={20} />
            <Skeleton
              width="100%"
              height={40}
              style={{ marginTop: "8px", borderRadius: "8px" }}
            />
          </div>

          {/* Skeleton for ComboBox */}
          <div>
            <Skeleton width={100} height={20} />
            <Skeleton
              width="100%"
              height={40}
              style={{ marginTop: "8px", borderRadius: "8px" }}
            />
          </div>

          {/* Skeleton for CV Upload */}
          <div>
            <Skeleton width={100} height={20} />
            <div className="mt-2">
              <Skeleton
                width={120}
                height={40}
                style={{ borderRadius: "8px" }}
              />
            </div>
          </div>
        </div>

        {/* Submit Button Skeleton */}
        <div className="flex">
          <Skeleton
            width={100}
            height={40}
            style={{ borderRadius: "8px", marginTop: "20px" }}
          />
        </div>
      </div>
    </div>
  );
}
